import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import rem from 'polished/lib/helpers/rem';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';

export const PanelWrapper = styled(Flex)`
  flex-direction: column;
  background: ${toColorString(color.base.snowWhite)};
`;

export const EntryRow = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 0.25)};
  padding: ${rem(spacing.base * 0.75)} ${rem(spacing.base)};

  &:not(:last-of-type) {
    border-bottom: ${rem(1)} solid ${toColorString(color.opacity.charcoal15)};
  }
`;

export const EntryTitle = styled(P)`
  font-weight: 600;
  margin: 0;
`;

export const EntryMeta = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
`;

export const EntryDate = styled(P)`
  color: ${toColorString(color.base.alaskanHusky)};
  margin: 0;
`;

export const PanelFooter = styled(Flex)`
  justify-content: center;
  padding: ${rem(spacing.base * 0.75)};
  border-top: ${rem(1)} solid ${toColorString(color.opacity.charcoal15)};
`;

export const EmptyState = styled(Flex)`
  justify-content: center;
  padding: ${rem(spacing.base * 1.5)};

  p {
    color: ${toColorString(color.base.alaskanHusky)};
    margin: 0;
  }
`;
